const ERRORS = {
  NL: {
    DEFAULT: 'Het verzoek is mislukt. Probeer het later opnieuw. Als het probleem aanhoudt, neem dan contact met ons op.',
    ERROR_CODE: 'Error code',

    PR: 'Foutieve inhoud ingevoerd. Als het probleem zich blijft voordoen, neem dan contact met ons op. Error code:',
    NE: 'Netwerk error, controleer alstublieft uw internet connectie. Als het probleem zich blijft voordoen, neem dan contact met ons op. Error code:',
    SE: 'Server niet bereikbaar, probeer het later nog een keer. Als het probleem zich blijft voordoen, neem dan contact met ons op. Error code:',
    OB: 'Object error, probeer het later nog een keer. Als het probleem zich blijft voordoen, neem dan contact met ons op. Error code:',
    OB_UG: 'Error, het is niet mogelijk om meerdere partners aan een enkele gebruiker toe te voegen.',
    DB: 'Database error, probeer het later nog een keer. Als het probleem zich blijft voordoen, neem dan contact met ons op. Error code:',
    TL: 'Error, Je kan niet een trip verwijderen die al gestart is',

    E_PR_001: 'De e-mail is ongeldig.',
    E_DA_001: 'Error, controleer de ingevoerde naam!',
    E_DA_002: 'Incorrecte email of wachtwoord.',
    E_DA_003: 'Een account met dit e-mailadres bestaat al.',
    E_DA_005: 'De e-mail is bij ons niet bekend.',
    E_DA_006: 'De koppeling is verlopen.',
    E_DA_007: 'Account is al geactiveerd. Het is niet nodig om het opnieuw te activeren.',
    E_DA_008: 'Uw oude wachtwoord is onjuist',
    E_OB_033: 'Error, de ingevoerde partner bestaat al in ons systeem!',
  },
  EN: {
    DEFAULT: 'The request failed. Please try again later. If the problem persists, please contact us.',
    ERROR_CODE: 'Error code',

    PR: 'Wrong content provided. If the problem persists, please contact us. Error code:',
    NE: 'Network error, check your internet connection. If the problem persists, please contact us. Error code:',
    SE: 'Server not reachable error, please try again later. If the problem persists, please contact us. Error code:',
    OB: 'Object error, please try again later. If the problem persists, please contact us. Error code:',
    OB_UG: 'It is not possible to add multiple partners to a single user.',
    DB: 'Database error, please try again later. If the problem persists, please contact us. Error code:',
    TL: "Error, you can't delete a trip which is already started",

    E_PR_001: 'The email is invalid.',
    E_DA_001: 'Error duplicated name!',
    E_DA_002: 'Incorrect email or password.',
    E_DA_003: 'An account with this email already exists.',
    E_DA_005: 'The email is unknown to us.',
    E_DA_006: 'The link has expired.',
    E_DA_007: 'Account has already been activated. No need to reactivate it.',
    E_DA_008: 'Your old password is incorrect',
    E_OB_033: 'Error, this partner already exists in the system!',
  },
  DE: {
    DEFAULT: 'Die Anfrage ist fehlgeschlagen. Bitte versuchen Sie es später erneut. Wenn das Problem weiterhin besteht, kontaktieren Sie uns bitte.',
    ERROR_CODE: 'Error code',

    E_PR_001: 'Die E-Mail ist ungültig.',
    E_DA_002: 'Falsche Email oder Passwort.',
    E_DA_003: 'Ein Konto mit dieser E-Mail ist bereits vorhanden.',
    E_DA_005: 'Die E-Mail ist uns unbekannt.',
    E_DA_006: 'Der Link ist abgelaufen.',
    E_DA_007: 'Konto wurde bereits aktiviert. Sie müssen es nicht erneut aktivieren.',
    E_DA_008: 'Ihr altes Passwort ist falsch',
  },
};

export { ERRORS as default };
